__turbopack_context__.v({
  "cubesFrame": "illustrations-module__fIPCPa__cubesFrame",
  "left": "illustrations-module__fIPCPa__left",
  "link": "illustrations-module__fIPCPa__link",
  "right": "illustrations-module__fIPCPa__right",
  "scene": "illustrations-module__fIPCPa__scene",
  "top": "illustrations-module__fIPCPa__top",
  "towerLed": "illustrations-module__fIPCPa__towerLed",
  "towerLeft": "illustrations-module__fIPCPa__towerLeft",
  "towerRight": "illustrations-module__fIPCPa__towerRight",
  "towerRow": "illustrations-module__fIPCPa__towerRow",
  "towerTop": "illustrations-module__fIPCPa__towerTop",
});
